export default function datesAreInSameWeek(date1, date2) {
	const weekStart = new Date(date1);
	weekStart.setDate(date1.getDate() - date1.getDay() + (date1.getDay() === 0 ? 0 : 1));

	const weekEnd = new Date(weekStart);
	weekEnd.setDate(weekStart.getDate() + 6);

	return date2 >= weekStart && date2 <= weekEnd;
}